// extracted by mini-css-extract-plugin
export default {"label":"UserPage_label__jHLGm","audit":"UserPage_audit__Edgp6"};